import * as Dialog from "@radix-ui/react-dialog";

import ModalModel from "../../../Models/Modal/Modal.Model";
import { ModalHeader } from "./Components/Modal.Layout";

const defaultStyle = {
  content: {
    margin: "auto",
    borderRadius: "8px",
    boxShadow: "0px 2px 4px rgba(0,0,0, 0.2)",
    maxWidth: "fit-content",
    minHeight: "150px",
    maxHeight: "fit-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflowX: "hidden",
    overflowY: "auto",
    padding: "0px",
    backgroundColor: "#F7F7F7"
  }
};

export const SSModal = () => {
  // We are starting our transition to hooks and the pullstate approach to everything.
  const { modalContent, modalHeader, showModal, modalHeight, modalWidth, shouldCloseOnOverlayClick, useDefaultUI } = ModalModel.useState();

  if (!showModal) return null;

  // Bare mode: caller's content owns the modal frame (e.g. AccountSettingsModal renders its own <Modal>).
  if (!useDefaultUI) return <>{modalContent}</>;

  const closeModal = () => {
    ModalModel.hideModal();
  };
  let style: any = { ...defaultStyle };
  if (modalWidth) {
    // style.left = "auto"
    // style.right = "auto"
    style.content = {
      ...style.content,
      height: `${modalHeight}px`,
      width: `${modalWidth}px`
    };
  }

  return (
    <Dialog.Root open={showModal} onOpenChange={closeModal}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-500 flex items-center justify-center bg-[rgba(94,84,80,0.2)] backdrop-blur-xs">
          <Dialog.Content
            className="relative w-full max-w-md rounded-lg bg-white p-5 shadow-lg"
            style={style.content}
            onEscapeKeyDown={closeModal}
            onPointerDownOutside={shouldCloseOnOverlayClick ? closeModal : undefined}
            onInteractOutside={shouldCloseOnOverlayClick ? closeModal : undefined}
          >
            <Dialog.Title className="sr-only">{modalHeader || "Start Shift Modal"}</Dialog.Title>
            {modalHeader && <ModalHeader>{modalHeader}</ModalHeader>}
            <div className="flex items-center justify-center p-5">{modalContent}</div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
